module.exports = __webpack_public_path__ + "static/media/instagram.def270ea.svg";